import React, { useCallback, useEffect, useRef, useState } from "react";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import { Modal } from "react-bootstrap";
import axios, { buildVideoIndexerManifestUrl } from "../../API/axios";
import { Link } from "react-router-dom";
import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SinglePostInteraction from "./SinglePostInteraction";
import SinglePostComment from "./SinglePostComment";
import SinglePostEngagement from "./SinglePostEngagement";
import { header, post, people } from "../../config/imagesLink";
import LikesDetails from "./LikesDetails";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import ZoomOutMapSharpIcon from '@mui/icons-material/ZoomOutMapSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import PostVideoCommon from "../PersonalProfile/PostVideoCommon";
import useThemeStore from "../../store/useThemeStore";
import Hls from "hls.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import { Token } from "@mui/icons-material";
import PostComponent from "./PostComponent";
import PollCard from "./PollCard";
import { ImageWithLoader } from "@skeleton";
import { useTranslation } from "react-i18next";
import formatPostContent, {
  formatExpandedPostContent,
} from "../../utility/formatPostContent";
import shouldShowPostReadMore from "../../utility/shouldShowPostReadMore";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';

import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";
import { Tooltip } from "@mui/material";
import { Portal } from "../../components/Portal";

const ImageSliderModal = ({
  setIspostmodalOpen,
  ispostmodalOpen,
  onRequestClose,
  isOpen,
  singlepostId,
  setIsfollowedComp,
  isfollowedComp,
  setIsLiked,
  isLiked,
  updateCommentCount,
  prevComments,
  AllPostListNews,
  updateCommentLike,
  setSinglePostId,
  setSinglePostContent,
  dLike,
  openModal,
  updateLikeCount,
  setDLike,
  isfollowed,
  setIsfollowed,
  sliderSettings,
  initialSlideIndex,
  setInitialSlideIndex,
  imageArray,
  setPostList,
  postList,
  updatePostLike,
  updateReplyCommentLike,
  initialPostItem,
}) => {
  const guestModeData = localStorage.getItem("guestMode");
  const isDark = useThemeStore((state) => state.isDark);
  const sessionId = localStorage.getItem("sessionId");
  const userUid = localStorage.getItem("userUid");
  const visibleVideoRef = useRef(null);
  const [activeVideoId, setActiveVideoId] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  const restrictedViewerTokens = localStorage.getItem("restrictedViewerToken");
  const { t } = useTranslation();
  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

  const handleMediaImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = post.noimgavailable;
  };
  const language = localStorage.getItem("Lang");
  const localeMap = {
    en: "en",
    ar: "ar",
    hi: "hi",
  };

  const locale = localeMap[language] || "en";
  const [singlepostList, setSinglePostList] = useState("");
  const [singlepostListinfo, setSinglePostListInfo] = useState("");
  const [singlepostCommentList, setSinglePostCommentList] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const iframeRef = useRef(null);

  const hydrateFromFeedItem = (feedItem) => {
    if (!feedItem?.postInfo) return false;
    const feedPostId = feedItem?.postInfo?.postId ?? feedItem?.postInfo?.postInfo?.postId;
    if (!feedPostId || String(feedPostId) !== String(singlepostId)) return false;

    setSinglePostListInfo(feedItem);
    setSinglePostList({ postInfo: feedItem });
    setModalLoading(false);
    return true;
  };

  const AllPostData = async () => {
    try {
      const resData = await axios.get(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${singlepostId}&RestrictedViewerToken=${restrictedViewerTokens}&langKey=${language}`,
      );
      const responseData = resData?.data?.responseData;
      setSinglePostList(responseData);
      setSinglePostListInfo(responseData?.postInfo);
    } catch (error) {
      console.log(error);
    } finally {
      setModalLoading(false);
    }
  };

  const AllPostComments = async () => {
    try {
      const resData = await axios.get(
        `/Posts/LoadAllComments?DeviceType=Web&PostId=${singlepostId}&langKey=${language}`,
      );
      setSinglePostCommentList(resData?.data?.responseData ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const AllPostList = () => {
    void AllPostData();
    void AllPostComments();
  };

  // Prefer feed imageArray (full list on open); fall back to GetPostInfo media
  const apiMediaList = singlepostListinfo?.postInfo?.mediaFilesList || [];
  const feedMediaList = Array.isArray(imageArray) ? imageArray : [];
  const mediaFilesList =
    feedMediaList.length >= apiMediaList.length && feedMediaList.length > 0
      ? feedMediaList
      : apiMediaList.length > 0
        ? apiMediaList
        : feedMediaList;

  const getMediaSrc = (media) =>
    typeof media === "string" ? media : media?.mediaName;

  const hasMultipleImages = mediaFilesList.length > 1;
  const isVideoPost =
    singlepostListinfo?.cntntTypCategory === "TextWithVideo" ||
    singlepostListinfo?.cntntTypCategory === "Video";
  const contentType = singlepostListinfo?.cntntTypCategory;
  const expectsImageMedia =
    contentType === "Image" ||
    contentType === "TextWithImage" ||
    contentType === "UserStory" ||
    (Array.isArray(mediaFilesList) && mediaFilesList.length > 0);
  const primaryMediaSrc = getMediaSrc(mediaFilesList[0]);
  const showModalImage =
    !isVideoPost && (Boolean(primaryMediaSrc) || expectsImageMedia);

  const settings = {
    dots: false,
    arrows: hasMultipleImages,
    infinite: hasMultipleImages,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: initialSlideIndex || 0,
  };

  const [showModal, setShowModal] = useState(false);
  const [postLikedType, setPostLikedType] = useState(false);
  const [postId, setPostId] = useState("");
  const [expandedPosts, setExpandedPosts] = useState({});
  const [postContentMap, setPostContentMap] = useState({});
  const [currentSlide, setCurrentSlide] = useState(initialSlideIndex || 0);
  const [fullSizeOpen, setFullSizeOpen] = useState(false);
  const fullSizeBtnRef = useRef(null);
  const sliderRef = useRef(null);

  const currentFullSizeSrc = getMediaSrc(
    mediaFilesList[currentSlide] || mediaFilesList[0]
  );

  const goToFullSizeSlide = useCallback(
    (nextIndex) => {
      if (!hasMultipleImages || mediaFilesList.length === 0) return;
      const total = mediaFilesList.length;
      const normalized = ((nextIndex % total) + total) % total;
      setCurrentSlide(normalized);
      sliderRef.current?.slickGoTo?.(normalized);
    },
    [hasMultipleImages, mediaFilesList.length]
  );

  const showPrevFullSizeImage = useCallback(
    (event) => {
      event?.stopPropagation?.();
      goToFullSizeSlide(currentSlide - 1);
    },
    [goToFullSizeSlide, currentSlide]
  );

  const showNextFullSizeImage = useCallback(
    (event) => {
      event?.stopPropagation?.();
      goToFullSizeSlide(currentSlide + 1);
    },
    [goToFullSizeSlide, currentSlide]
  );

  const openFullSizeImage = useCallback((event) => {
    event?.stopPropagation?.();
    setFullSizeOpen(true);
  }, []);

  const closeFullSizeImage = useCallback(() => {
    setFullSizeOpen(false);
    requestAnimationFrame(() => fullSizeBtnRef.current?.focus());
  }, []);

  const handleFullSizeTriggerKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openFullSizeImage(event);
    }
  };

  const handleShowModal = (item) => {
    setPostId(item.postId);
    setPostLikedType(item.likedType);
    setShowModal(true);
  };

  const handleLikesCloseModal = () => {
    setShowModal(false);
  };

  const handleCloseModal = useCallback(() => {
    if (fullSizeOpen) {
      closeFullSizeImage();
      return;
    }

    if (showModal) {
      setShowModal(false);
      return;
    }

    onRequestClose({
      postId: singlepostListinfo?.postInfo?.postId || singlepostId,
      postSnapshot: singlepostListinfo,
      commentsSnapshot: singlepostCommentList,
    });
    setIspostmodalOpen(false);
    setSinglePostId("");
    setInitialSlideIndex(0);
  }, [
    fullSizeOpen,
    closeFullSizeImage,
    showModal,
    onRequestClose,
    singlepostListinfo,
    singlepostCommentList,
    singlepostId,
    setIspostmodalOpen,
    setSinglePostId,
    setInitialSlideIndex,
  ]);

  useEscapeKeyDown(isOpen, handleCloseModal);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (e) => {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;

      if (fullSizeOpen) {
        if (!hasMultipleImages) return;
        e.preventDefault();
        goToFullSizeSlide(
          e.key === "ArrowLeft" ? currentSlide - 1 : currentSlide + 1
        );
        return;
      }

      if (e.key === "ArrowLeft") {
        document.querySelector(".slick-prev")?.click();
      } else if (e.key === "ArrowRight") {
        document.querySelector(".slick-next")?.click();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [
    isOpen,
    fullSizeOpen,
    hasMultipleImages,
    currentSlide,
    goToFullSizeSlide,
  ]);

  useEffect(() => {
    setCurrentSlide(initialSlideIndex || 0);
    setFullSizeOpen(false);
  }, [singlepostId, initialSlideIndex, isOpen]);


  // Hide body scroll when modal is open using a CSS class
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('imageslider-modal-open');
    } else {
      document.body.classList.remove('imageslider-modal-open');
    }

    return () => {
      document.body.classList.remove('imageslider-modal-open');
    };
  }, [isOpen]);

  const processExpandedContent = formatExpandedPostContent;

  const readMore = async (id) => {
    try {
      if (postContentMap[id]) {
        setExpandedPosts((prev) => ({ ...prev, [id]: true }));
        return;
      }

      const res = await axios.get(
        `/Posts/GetPostMainContent?DeviceType=Web&PostId=${id}&langKey=${language}`
      );

      setPostContentMap((prev) => ({
        ...prev,
        [id]: res.data.responseData,
      }));

      setExpandedPosts((prev) => ({
        ...prev,
        [id]: true,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const formattedContent = formatPostContent(
    singlepostListinfo?.postInfo?.postContent,
    singlepostListinfo?.postInfo?.dynamicValues
  );

  useEffect(() => {
    if (!isOpen || !singlepostId) return;

    const hydrated = hydrateFromFeedItem(initialPostItem);
    if (!hydrated) {
      setModalLoading(true);
    }

    AllPostList();
  }, [singlepostId, isOpen, initialPostItem]);

  const reloadVideo = () => {
    // console.log("hiiiiiiiiiiiiiiii");

    const iframe = iframeRef.current;
    if (iframe) {
      // Force reload by resetting src
      const originalSrc = iframe.src;
      iframe.src = '';
      setTimeout(() => {
        iframe.src = originalSrc;
      }, 100); // small delay ensures reload
    }
  };

  const videoRef = useRef(null);
  // const sharedVideoRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const videoId = singlepostListinfo?.postInfo?.mediaFilesList?.[0]?.mediaInfo;
    // const accountId = "3933d146-5f68-41d4-93a3-d2f7454d4a8d";
    const region = "centralindia";

    console.log("videoId:", videoId);
    // console.log("token:", restrictedViewerToken);

    if (!videoId || !restrictedViewerTokens || !videoRef.current) {
      console.error("Missing videoId or token or ref.");
      return;
    }

    const manifestUrl = buildVideoIndexerManifestUrl({ videoId: videoId, accessToken: restrictedViewerTokens });
    // console.log("manifestUrl:", manifestUrl);
    let hls;
    let plyrInstance;

    if (Hls.isSupported()) {
      hls = new Hls();
      hls.loadSource(manifestUrl);
      hls.attachMedia(videoRef.current);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        console.log("Manifest parsed");
        plyrInstance = new Plyr(videoRef.current, {
          captions: { active: true, update: true, language: "en" },
        });

        // Wait for a short time, then try to play
        videoRef.muted = true; // always start muted
        videoRef.current?.play().catch(err => {
          console.warn("Play interrupted", err);
        });

      });

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error("HLS.js Error:", data);
      });
    } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
      console.log(" Native HLS fallback");
      videoRef.current.src = manifestUrl;
      // plyrInstance = new Plyr(videoRef.current);
      videoRef.current.addEventListener("loadedmetadata", () => {
        videoRef.current?.play();
      });
    }
    return () => {
      // if (plyrInstance) plyrInstance.destroy();
      if (hls) hls.destroy();
    };
  }, [ispostmodalOpen, restrictedViewerTokens]);


  const shouldShowModal =
    isOpen && singlepostListinfo?.cntntTypCategory && singlepostListinfo?.postInfo;

  console.log("singadhfsdas", singlepostListinfo);

  const getRelativeTime = (singlepostListinfo) => {
    const now = moment.utc().local();
    const itemTime = moment
      .utc(singlepostListinfo?.postInfo?.creationTime)
      .local();

    const diffSeconds = now.diff(itemTime, "seconds");
    const diffMinutes = now.diff(itemTime, "minutes");
    const diffHours = now.diff(itemTime, "hours");
    const diffDays = now.diff(itemTime, "days");
    const diffMonths = now.diff(itemTime, "months", true);
    const diffYears = now.diff(itemTime, "years", true);

    /* JUST NOW */
    if (diffSeconds < 60) {
      return t("Notifications.Just Now");
    }

    /* MINUTES */
    if (diffMinutes < 60) {
      return diffMinutes === 1
        ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
        : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
    }

    /* HOURS */
    if (diffHours < 24) {
      return diffHours === 1
        ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
        : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
    }

    /* DAYS */
    if (diffDays < 30) {
      return diffDays === 1
        ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
        : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
    }

    /* MONTHS */
    if (diffMonths < 12) {
      const displayMonth =
        diffMonths >= 0.75 && diffMonths < 1.25
          ? 1
          : Math.round(diffMonths * 2) / 2;

      return displayMonth === 1
        ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
        : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
    }

    /* YEARS */
    const displayYear =
      diffYears >= 0.75 && diffYears < 1.25
        ? 1
        : Math.round(diffYears * 2) / 2;

    return displayYear === 1
      ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
      : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
  };


  return (
    <>


      {/* {console.log("singlepostListinfo", singlepostListinfo)} */}

      {/* {isOpen && ( */}
      <Portal layer="modal">
        <div
          className={`${singlepostListinfo?.cntntTypCategory === "Text" ? "modal-md" : "modal-xl"
            } modal fade show postAdd`}
          // className={`
          //   ${Array.isArray(singlepostListinfo?.postInfo?.mediaFilesList) ||
          //   singlepostListinfo?.postInfo?.mediaFilesList?.length === 0
          //   ? "modal-xl"
          //   : "modal-md"
          //   } modal fade show postAdd`}
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div
            className="modal-dialog modal-dialog-centered m-auto"
            role="document"
          >
            <div
              className="modal-content ImagesliderScroller d-flex flex-column m-auto MobileCommentmodal"
              style={{ overflowY: "auto" }}
            >
              <div className="modalBorder d-flex justify-content-between align-items-center p-3">
                {isDark ? (
                  <div className="Logo">
                    <img src={header.whiteoglogo} alt="" width={130} />
                  </div>
                ) : (
                  <div className="Logo">
                    <img src={header.oglogo} alt="" width={130} />
                  </div>
                )}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  role="button"
                  aria-label={t("modals.Close") || "Close"}
                  tabIndex={0}
                  onClick={handleCloseModal}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleCloseModal();
                    }
                  }}
                />
              </div>

              {modalLoading && !singlepostListinfo?.postInfo ? (
                <div className="d-flex justify-content-center align-items-center w-100 flex-grow-1">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{t("modals.Loading")}</span>
                  </div>
                </div>
              ) : (
                <>

                  <div className="row w-100 m-0 image-slider-modal-row">
                    <div
                      className={`${singlepostListinfo?.cntntTypCategory === "Text"
                        ? "d-none"
                        : "col-12 col-lg-7"
                        } p-0 image-slider-media-col`}
                    >
                      {showModalImage ? (
                        <button
                          ref={fullSizeBtnRef}
                          type="button"
                          className="wljSecondaryBtn image-slider-fullsize-btn"
                          onClick={openFullSizeImage}
                          aria-haspopup="dialog"
                          aria-expanded={fullSizeOpen}
                        >
                          <ZoomOutMapSharpIcon className="material-symbols-sharp" />
                          {t("Newsfeed.Full Size Image")}
                        </button>
                      ) : null}
                      <div className="image-slider-modal commentSection text-center">
                        {!isVideoPost && hasMultipleImages ? (
                          <Slider
                            ref={sliderRef}
                            key={`${singlepostId}-${mediaFilesList.length}-${initialSlideIndex}`}
                            {...settings}
                            afterChange={setCurrentSlide}
                          >
                            {mediaFilesList.map((image, index) => (
                              <div key={`${getMediaSrc(image) || "media"}-${index}`} className="d-flex justify-content-center align-items-center" style={{ maxHeight: "85vh" }}>
                                <div
                                  className="image-slider-fullsize-trigger w-100 d-flex justify-content-center align-items-center"
                                  role="button"
                                  tabIndex={0}
                                  style={{ padding: "20px" }}
                                  onClick={openFullSizeImage}
                                  onKeyDown={handleFullSizeTriggerKeyDown}
                                >
                                  <ImageWithLoader
                                    src={getMediaSrc(image)}
                                    alt=""
                                    className="img-fluid m-auto modal-image"
                                    style={{ maxHeight: "85vh", maxWidth: "100%", height: "auto", objectFit: "contain" }}
                                    onError={handleMediaImageError}
                                  />
                                </div>
                              </div>
                            ))}
                          </Slider>
                        ) : (
                          <>
                          {showModalImage ? (
                            <div
                              className="image-slider-fullsize-trigger w-100 d-flex justify-content-center align-items-center"
                              role="button"
                              tabIndex={0}
                              style={{ padding: "20px", maxHeight: "85vh" }}
                              onClick={openFullSizeImage}
                              onKeyDown={handleFullSizeTriggerKeyDown}
                            >
                              <ImageWithLoader
                                src={primaryMediaSrc}
                                alt=""
                                className="img-fluid"
                                style={{ maxHeight: "85vh", maxWidth: "100%", height: "auto", objectFit: "contain" }}
                                onError={handleMediaImageError}
                              />
                            </div>
                          ) : null}

                            {isVideoPost &&
                              singlepostListinfo?.postInfo?.mediaFilesList?.[0]
                                ?.mediaInfo ? (
                              <div
                                className="w-100 d-flex justify-content-center align-items-center"
                                style={{
                                  padding: "20px",
                                  maxHeight: "85vh"
                                }}>
                                <div className="w-100 d-flex justify-content-center align-items-center" style={{ maxHeight: "100%" }}>
                                  <PostVideoCommon
                                    file={singlepostListinfo?.postInfo?.mediaFilesList?.[0]}
                                    item={singlepostListinfo}
                                    restrictedViewerToken={restrictedViewerTokens}
                                    setActiveVideoId={setActiveVideoId}
                                    activeVideoId={activeVideoId}
                                    AllPostList={AllPostList}
                                    setPostList={setPostList}
                                    visibleVideoRef={visibleVideoRef} />
                                </div>
                              </div>
                            ) : !isVideoPost && !showModalImage ? (
                              <>
                                <PostComponent item={singlepostListinfo} restrictedViewerToken={restrictedViewerTokens} isOpen={isOpen} isModalView={true} />
                              </>
                            ) : null}
                          </>
                        )}
                      </div>
                    </div>

                    <div
                      className={`${singlepostListinfo?.cntntTypCategory === "Text"
                        ? "col-12"
                        : "col-12 col-lg-5"
                        } p-0 ModifyScrollBar image-slider-details-col`}
                    // className={` ${Array.isArray(singlepostListinfo?.postInfo?.mediaFilesList) ||
                    //   singlepostListinfo?.postInfo?.mediaFilesList?.length === 0
                    //   ? "col-md-4"
                    //   : "col-md-12"
                    //   } p-0`}
                    >
                      <div className="featured-card user-postOnlyContent p-2 m-2">
                        <div className="feature-content p-2 d-flex justify-content-between">
                          <Link to={singlepostListinfo?.postInfo?.postOriginType === "Company" ? `/Company/${singlepostListinfo?.postInfo?.userUid}` : `/User/${singlepostListinfo?.postInfo?.userUid}`}>
                            <div className="d-flex align-items-center">
                              <div className="ImgAvatar">
                                <img
                                  src={singlepostListinfo?.postInfo?.userAvatar || people.DefaultProfile}
                                  alt=""
                                  style={{ borderRadius: "50px" }}
                                  onError={handleProfileImageError}
                                />
                              </div>
                              <div className="ms-2">
                                <h4 className="f-14 fw-bold mb-0">
                                  {singlepostListinfo?.postInfo?.userName}
                                </h4>
                                {/* <p className="f-12">
                                  {moment
                                    .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                    .local()
                                    .format("DD MMMM YYYY [at] h:mm a")}
                                </p> */}
                                {language === "ar" ? (
                                  <Tooltip title={moment
                                    .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                    .locale(locale)
                                    .local()
                                    .format("D MMMM YYYY [الساعة] h:mm a")} arrow>
                                    <p className="f-10 label">
                                      {moment
                                        .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                        .locale(locale)
                                        .local()
                                        .format("D MMMM YYYY [الساعة] h:mm a")}
                                    </p>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title={moment
                                    .utc(singlepostList?.postInfo?.postInfo?.creationTime)
                                    .local()
                                    .format(language === "en"
                                      ? "D MMMM YYYY [at] h:mm a"
                                      : "D MMMM YYYY [को] h:mm a")} arrow>
                                    <p className="f-10 label">
                                      {getRelativeTime(singlepostListinfo)}</p>
                                  </Tooltip>


                                )}

                              </div>
                            </div>
                          </Link>
                          {guestModeData === "true" ? null : (
                            <div className="row">
                              <div>
                                <SinglePostInteraction
                                  postId={singlepostListinfo?.postInfo?.postId}
                                  AllPostComments={AllPostComments}
                                  AllPostList={AllPostList}
                                  singlepostList={singlepostListinfo?.postInfo}
                                  singlepostListData={singlepostListinfo}
                                  AllPostListNews={AllPostListNews}
                                  setSinglePostList={setSinglePostList}
                                  PostOriginType={"User"}
                                  postOriginId={userUid}
                                  isfollowedComp={isfollowedComp}
                                  setIsfollowedComp={setIsfollowedComp}
                                  setIsConnected={setIsConnected}
                                  isConnected={isConnected}
                                  isfollowed={isfollowed}
                                  setIsfollowed={setIsfollowed}
                                  setPostList={setPostList}
                                />
                              </div>
                            </div>
                          )}
                        </div>

                        {singlepostListinfo?.postInfo?.postContent && (
                          <div className="f-14 p-2 postContent">
                            <>
                              {!expandedPosts?.[singlepostListinfo?.postInfo?.postId] && (
                                <div
                                  className="postContentDiv"
                                  dangerouslySetInnerHTML={{
                                    __html: formattedContent,
                                  }}
                                />
                              )}

                              {!expandedPosts?.[singlepostListinfo?.postInfo?.postId] &&
                                shouldShowPostReadMore(
                                  singlepostListinfo?.postInfo?.postContent,
                                  singlepostListinfo?.postInfo?.readMore
                                ) && (
                                  <span style={{ color: "#1051b0" }}
                                    onClick={() => readMore(singlepostListinfo?.postInfo?.postId)}
                                    className="pointer"
                                  >
                                    {t("Newsfeed.Read More")}
                                  </span>
                                )}

                              {expandedPosts?.[singlepostListinfo?.postInfo?.postId] &&
                                postContentMap?.[singlepostListinfo?.postInfo?.postId] && (
                                  <div
                                    className="postContentDiv f-14"
                                    dangerouslySetInnerHTML={{
                                      __html: processExpandedContent(
                                        postContentMap[singlepostListinfo?.postInfo?.postId],
                                        singlepostListinfo?.postInfo?.dynamicValues
                                      ),
                                    }}
                                  />
                                )}

                              {expandedPosts?.[singlepostListinfo?.postInfo?.postId] && (
                                <span style={{ color: "#1051b0" }}
                                  className="pointer"
                                  onClick={() =>
                                    setExpandedPosts((prev) => ({
                                      ...prev,
                                      [singlepostListinfo?.postInfo?.postId]: false,
                                    }))
                                  }
                                >
                                  {t("Newsfeed.Read Less")}
                                </span>
                              )}
                            </>
                          </div>
                        )}

                        {singlepostListinfo?.postInfo?.postId && (
                          <div className="px-2 pb-1">
                            <PollCard postId={singlepostListinfo.postInfo.postId} eager />
                          </div>
                        )}

                        <div className="feed-post p-2">
                          {guestModeData === "true" ? null : (
                            <div className="row">
                              <div className="addComment">
                                <SinglePostComment
                                  isOwnedPost={singlepostListinfo?.postInfo?.isOwned}
                                  postId={singlepostListinfo?.postInfo?.postId}
                                  AllPostList={AllPostList}
                                  singlepostList={singlepostList}
                                  setSinglePostList={setSinglePostList}
                                  AllPostComments={AllPostComments}
                                  ispostmodalOpen={ispostmodalOpen}
                                  setIspostmodalOpen={setIspostmodalOpen}
                                  setPostList={setPostList}
                                  setSinglePostCommentList={setSinglePostCommentList}
                                  singlepostCommentList={singlepostCommentList}
                                  videoRef={videoRef}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        <div
                          className={`postData d-flex align-items-center justify-content-between ${singlepostListinfo?.postInfo?.likeCount === 0 &&
                            singlepostListinfo?.commentCount === 0 &&
                            singlepostList?.postInfo?.postInfo?.shareCount === 0
                            ? ""
                            : "border-custom1"
                            }`}
                          style={{
                            direction: language === "ar" ? "rtl" : "ltr",
                            textAlign: language === "ar" ? "right" : "left",
                          }}
                        >
                          <div className="ms-2">
                            {singlepostListinfo?.postInfo?.likeCount === 0 || singlepostListinfo?.postInfo?.likeCount === null ? (
                              ""
                            ) : (
                              <p
                                className="f-10 pointer like-details"
                                onClick={() => handleShowModal(singlepostListinfo)}
                              >
                                {singlepostListinfo?.postInfo?.likeCount} <ThumbUpOutlinedIcon style={{ color: "#00419f", fontSize: "13px" }} />
                                {/* {t("Newsfeed.Like")} */}
                              </p>
                            )}
                          </div>
                          <div className=" d-flex">
                            {(singlepostListinfo?.postInfo?.commentCount ?? 0) > 0 && (
                              <p className="f-10 me-2 pointer like-details">
                                {singlepostCommentList?.length > 0
                                  ? singlepostCommentList.length
                                  : singlepostListinfo?.postInfo?.commentCount}{" "}
                                <ChatOutlinedIcon
                                  style={{ color: "#00419f", fontSize: "13px" }} />
                              </p>
                            )}

                            {(singlepostListinfo?.postInfo?.shareCount ?? 0) > 0 && (
                              <p className="f-10">
                                & {singlepostListinfo.postInfo.shareCount} {t("Newsfeed.Share")}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="postengagement">
                          <SinglePostEngagement
                            setIsLiked={setIsLiked}
                            isLiked={isLiked}
                            isOwnedPost={singlepostListinfo?.postInfo?.isOwned}
                            AllPostComments={AllPostComments}
                            updateCommentCount={updateCommentCount}
                            postId={singlepostListinfo?.postInfo?.postId}
                            AllPostList={AllPostList}
                            AllPostData={AllPostData}
                            postList={postList}
                            singlepostListinfo={singlepostListinfo}
                            setSinglePostListInfo={setSinglePostListInfo}
                            singlepostList={singlepostList}
                            setSinglePostList={setSinglePostList}
                            ispostmodalOpen={ispostmodalOpen}
                            setIspostmodalOpen={setIspostmodalOpen}
                            openModal={openModal}
                            setSinglePostId={setSinglePostId}
                            setSinglePostContent={setSinglePostContent}
                            setDLike={setDLike}
                            updateLikeCount={updateLikeCount}
                            setPostList={setPostList}
                            setSinglePostCommentList={setSinglePostCommentList}
                            singlepostCommentList={singlepostCommentList}
                            updateCommentLike={updateCommentLike}
                            updatePostLike={updatePostLike}
                            updateReplyCommentLike={updateReplyCommentLike}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {/* )} */}

        {/* {showModal && ( */}
        <LikesDetails
          showModal={showModal}
          handleLikesCloseModal={handleLikesCloseModal}
          postId={singlepostListinfo?.postInfo?.postId}
          postLikedType={postLikedType}
        />
      </Portal>
      {fullSizeOpen ? (
        <Portal layer="modal">
          <div
            className="image-fullsize-overlay"
            role="dialog"
            aria-modal="true"
            aria-label={t("Newsfeed.Full Size Image")}
            onClick={closeFullSizeImage}
          >
            <button
              type="button"
              className="image-fullsize-overlay__close"
              aria-label={t("modals.Close") || "Close"}
              onClick={closeFullSizeImage}
            >
              <CloseSharpIcon className="material-symbols-sharp pointer" />
            </button>
            {hasMultipleImages ? (
              <>
                <button
                  type="button"
                  className="image-fullsize-overlay__nav image-fullsize-overlay__nav--prev"
                  aria-label={t("Newsfeed.Previous") || "Previous"}
                  onClick={showPrevFullSizeImage}
                >
                  <ArrowBackIosNewSharpIcon className="material-symbols-sharp" />
                </button>
                <button
                  type="button"
                  className="image-fullsize-overlay__nav image-fullsize-overlay__nav--next"
                  aria-label={t("Newsfeed.Next") || "Next"}
                  onClick={showNextFullSizeImage}
                >
                  <ArrowForwardIosSharpIcon className="material-symbols-sharp" />
                </button>
                <div
                  className="image-fullsize-overlay__counter"
                  onClick={(event) => event.stopPropagation()}
                >
                  {currentSlide + 1} / {mediaFilesList.length}
                </div>
              </>
            ) : null}
            <img
              src={currentFullSizeSrc}
              alt={t("Newsfeed.Full Size Image")}
              className="image-fullsize-overlay__img"
              onClick={(event) => event.stopPropagation()}
              onError={handleMediaImageError}
            />
          </div>
        </Portal>
      ) : null}
      {/* )} */}
    </>
  );
};

export default ImageSliderModal;